require('waypoints/lib/noframework.waypoints.min');

const runAnimations = () => {
  const wayPointEl = document.querySelectorAll('.waypoint');

  for (let i = 0; i < wayPointEl.length; i++) {
    const element = wayPointEl[i];
    // eslint-disable-next-line
    new Waypoint({
      element,
      handler: () => {
        element.classList.add('inView');
      },
      offset: '50%',
    });
  }
};

// Init our functions on page load.
document.addEventListener('DOMContentLoaded', () => {
  runAnimations();
});

export default runAnimations;



// WEBPACK FOOTER //
// ./assets/js/src/animations.js